import axios from '~/axiosWrapper';
import { jsonToFormData } from '~/app/helpers/headerContentType';
import { API } from '~/app/routes';
import { IssueDetails, IssuePayload, IssueResponsePayload } from '~/types';
import { assertOnlineForRemote } from './remoteGuard';

export class IssueRemoteDataSource {
  fetchIssue(id: IssueDetails['id']): Promise<IssueDetails> {
    assertOnlineForRemote();
    return axios.get(`${API.issue}/${id}`);
  }

  fetchFavoriteIssues(scope: IssueDetails['id']): Promise<IssueDetails[]> {
    assertOnlineForRemote();
    return axios.get(`${API.issue}/${scope}`);
  }

  saveIssue(payload: IssuePayload): Promise<IssueResponsePayload> {
    assertOnlineForRemote();
    return axios.post(`${API.issue}/save`, jsonToFormData(payload));
  }
}

export const issueRemote = new IssueRemoteDataSource();
